
import { ACLEntityTypeDto } from './aclEntityType.dto';
import { ACLInheritDataTaskDto } from './aclInheritDataTask.dto';
import { BaseDto } from './base.dto';

export enum ACLOperationType{
    SHARE=1,
    COPY,
    COPY_AND_RESET_TO_DEFAULT_VALUE
}


export class ACLInheritDataStepDto extends BaseDto{  
    inheritDataTask: ACLInheritDataTaskDto;
    sequence: number;
    entityType: ACLEntityTypeDto;
    description?: string;
    operationType: ACLOperationType;
    enabled: boolean;
    
}